class BuyButtonPrice extends HTMLElement {
  connectedCallback() {
    this._abortController = new AbortController();
    const { signal } = this._abortController;

    try {
      this._data = JSON.parse(this.querySelector('script')?.textContent || '{}');
    } catch {
      this._data = {};
    }

    this._target = this.closest('.product-info')?.querySelector('[data-atc-price]');
    if (!this._target) return;

    this.form?.addEventListener('change', () => this._renderNow(), { signal });
    document.addEventListener('variant:change', () => this._renderNow(), { signal });

    this._render();
  }

  disconnectedCallback() {
    this._abortController?.abort();
  }

  _renderNow() {
    this._render();
    setTimeout(() => this._render(), 0);
  }

  get form() {
    return document.forms[this.getAttribute('form')];
  }

  get variantId() {
    return this.form?.elements?.id?.value || this.getAttribute('data-initial-variant');
  }

  get sellingPlanId() {
    const field = this.form?.elements?.selling_plan;
    if (!field) return '';

    const value = field.value ?? field[0]?.value ?? '';
    return field.disabled ? '' : String(value);
  }

  _render() {
    const variant = this._data[this.variantId];
    if (!variant) return;

    const price = variant.plans?.[this.sellingPlanId] || variant.price;
    if (price && this._target.textContent !== price) this._target.textContent = price;
  }
}

if (!window.customElements.get('buy-button-price')) {
  window.customElements.define('buy-button-price', BuyButtonPrice);
}
